<template>
    <div class="mypage_common">
        <div class="common_head">
            <h5>비밀번호변경</h5>
            <p>비밀번호는 8~16자의 숫자, 영문 대/소문자, 특수문자 중 2가지 이상 조합하여 사용가능합니다.</p>
        </div>
        <div class="common_body">
            <div class="tbl_wrap">
                <table class="common pass">
                    <tbody>
                        <tr>
                            <th>
                                현재비밀번호
                            </th>
                            <td>
                                <div class="wrapper">
                                    <input type="password" placeholder="현재 비밀번호 입력" v-model="currentPassword">
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <th>
                                변경할 비밀번호
                            </th>
                            <td>
                                <div class="wrapper">
                                    <input type="password" placeholder="8~16자 이내의 영문 대/소문자, 숫자, 특수문자중 2가지 이상 조합하여 사용 가능" v-model="newPassword" @input="validatePassword">
                                    <span class="not">{{ passwordError }}</span>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <th>
                                변경할 비밀번호 확인
                            </th>
                            <td>
                                <div class="wrapper">
                                    <input type="password" placeholder="비밀번호 확인을 위해 한번 더 입력" v-model="newPasswordCheck">
                                    <span v-if="newPassword !== newPasswordCheck">비밀번호가 일치하지 않습니다.</span>
                                    <span v-else>비밀번호가 일치합니다.</span>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="btn_wrap">
                <button type="button" class="btn_cancel">취소</button>
                <button type="button" class="btn_check" @click="changePassword">확인</button>
            </div>
        </div>
    </div>
</template>
<script>
import { mapActions, mapState } from 'vuex';

const accountModule = 'accountModule'

export default {
  data () {
    return {
      currentPassword: '',
      newPassword: '',
      newPasswordCheck: '',
      passwordError: ''
    }
  },
  methods: {
    ...mapActions(accountModule, ['requestChangePassword']),

    async changePassword() {
      const isValid = this.validation()
      if (isValid) {
        this.$openModal('alertModal', {
          message: isValid
        })
        return
      }

      const {currentPassword, newPassword} = this
      const result = await this.requestChangePassword({currentPassword, newPassword})
      if (result.result === 'success') {
        this.$openModal('alertModal', {
          message: "비밀번호 변경이 완료 됐습니다."
        })
        this.$router.push({ name: 'MyPage' })
      } else {
        this.$openModal('alertModal', {
          message: result.message
        })
      }
      
    },

    validation() {
      if (this.currentPassword.length < 1) return '현재 비밀번호를 입력해주세요'
      if (this.newPassword.length < 1) return '변경할 비밀번호를 입력해주세요'
      if (this.newPasswordCheck.length < 1) return '변경할 비밀번호 확인을 입력해 주세요'
      if (this.newPassword != this.newPasswordCheck) return '비밀번호와 비밀번호 확인이 일치하지 않습니다.'
      if (this.passwordError === "비밀번호 조합 기준에 적합하지 않습니다.") return this.passwordError
    },

    validatePassword() {
      const passwordRule = /^(?=.*[A-Za-z])(?=.*\d|.*[\W_])[A-Za-z\d\W_]{8,16}$/;
      if (!passwordRule.test(this.newPassword)) {
        this.passwordError = "비밀번호 조합 기준에 적합하지 않습니다.";
      } else {
        this.passwordError = "사용가능한 비밀번호입니다.";
      }
    }
  }
}
</script>